import { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { AiOutlineClose, AiOutlineCamera } from "react-icons/ai";
import ButtomButton from "../../components/DocButtomButton";
import CustomInput from "../../components/CustomInput";
import { createCommunity } from "../../actions/community.action";
import ErrorInputComponent from "../../components/ErrorInputComponent";
import { Loading } from "../../utils/helpers/constants";
import { imageValidator } from "../../utils/helpers/dataHelper";
import { categories } from "../../utils/mapper/enums/AppEnums";

export default function CreateCommunityModal({
  open,
  setOpen,
  cancelButtonRef,
}) {
  const dispatch = useDispatch();
  const [modalState, setModalState] = useState(false);
  const [imageError, setImageError] = useState("");
  const [imageDetails, setImageDetails] = useState({
    imagePreview: "",
    file: "",
  });

  const {
    community: { communityLoading },
  } = useSelector(({ communityReducer }) => ({
    community: communityReducer,
  }));

  const validationSchema = Yup.object({
    name: Yup.string().required("name is required"),
    description: Yup.string().required("description is required"),
    category: Yup.string().required("category is required"),
  });
  const { handleSubmit, handleChange, values, errors } = useFormik({
    initialValues: {
      name: "",
      description: "",
      category: "MUSIC",
    },
    validationSchema,
    onSubmit(values) {
      const formData = new FormData();
      const payload = {
        name: values.name,
        description: values.description,
        category: values.category,
      };
      const stringRequest = JSON.stringify(payload);
      formData.append("imageFile", imageDetails.file);
      const blobRequest = new Blob([stringRequest], {
        type: "application/json",
      });
      formData.append("request", blobRequest);
      const imageFile = imageDetails.file;
      if (imageFile === "") {
        setImageError("image is required");
      } else {
        dispatch(createCommunity(formData));
        setModalState(true);
      }
    },
  });

  const onImageUpload = (event) => {
    if (event.target.files && event.target.files[0]) {
      setImageError("");
      let reader = new FileReader();
      let file = event.target.files[0];
      let isValid = imageValidator(file);
      if (isValid) {
        reader.onloadend = () => {
          setImageDetails({
            ...imageDetails,
            imagePreview: reader.result,
            file: file,
          });
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const communityCategories = [
    { name: "Music", value: "MUSIC" },
    { name: "Technology", value: "TECHNOLOGY" },
    { name: "Religion", value: "RELIGION" },
    { name: "Sports", value: "SPORTS" },
  ];

  const buttonLoadState = communityLoading === Loading.FETCHING;
  const loadState = communityLoading === Loading.SUCCESS;

  // useEffect(() => {
  //   if (loadState && modalState) {
  //     setOpen(false);
  //   } else {
  //   }
  // });

  return (
    <div>
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          initialFocus={cancelButtonRef}
          onClose={setOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-end sm:items-cente justify-center min-h-full p-4 text-cente sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-lg sm:w-full">
                  <div className="">
                    <div className="">
                      <div className="mb-6 bg-gray-800 p-4 rounded-t-md">
                        <div className="flex  text-xl items-center text-white">
                          <AiOutlineClose
                            onClick={() => setOpen(false)}
                            className="cursor-pointer"
                          />
                          <div className="ml-auto mr-auto font-bold">
                            Create Community
                          </div>
                        </div>
                      </div>
                      <div className="text-lg mt-5 sm:px-6 px-6 w-full">
                        Create focused group discussion forums to join and
                        discuss pressing matters.
                      </div>
                      <div className="mt-5 sm:px-6 px-6 w-full">
                        <form>
                          <CustomInput
                            handleChange={handleChange}
                            name="name"
                            placeholder="Community Title"
                          />
                          <ErrorInputComponent error={errors.name} />

                          <div className="inline-block relative w-full mb-5">
                            <select
                              placeholder="Community Category"
                              name="category"
                              onChange={handleChange}
                              className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 pt-4 pb-4 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                            >
                              {categories.map((cat, index) => {
                                return (
                                  <option key={index} value={cat.value}>
                                    {cat.name}
                                  </option>
                                );
                              })}
                            </select>
                            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                              <svg
                                className="fill-current h-4 w-4"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                              >
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                              </svg>
                            </div>
                            <ErrorInputComponent error={errors.category} />
                          </div>
                          <div className="mb-5">
                            <textarea
                              className="mb-2 appearance-none border border-gray-400 rounded w-full pt-4 pb-4 py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-green-800"
                              id="inline-full-name"
                              type="textarea"
                              name="description"
                              rows={5}
                              onChange={handleChange}
                              placeholder="Community Description"
                            />
                            <ErrorInputComponent error={errors.description} />
                          </div>
                          <div className="mb-3">
                            {imageDetails.imagePreview !== "" ? (
                              <div className="doc_processing_colo">
                                <div className="flex items-center justify-center">
                                  <label className="cursor-pointer flex flex-col h-full w-full p-2 rounded-md border border-green-800 border-dashed hover:bg-gray-100 hover:border-gray-300">
                                    <img
                                      className="h-full w-full"
                                      src={imageDetails.imagePreview}
                                    />
                                    <input
                                      type="file"
                                      className="opacity-0"
                                      onChange={(e) => onImageUpload(e)}
                                      name="image"
                                    />
                                  </label>
                                </div>
                              </div>
                            ) : (
                              <div className="doc_processing_colo">
                                <div className="flex items-center justify-center">
                                  <label className="cursor-pointer flex flex-col h-24 w-full p-2 rounded-md border border-green-800 border-dashed hover:bg-gray-100 hover:border-gray-300">
                                    <div className="flex flex-col items-center justify-center p-2">
                                      <AiOutlineCamera
                                        size={25}
                                        color="green"
                                      />
                                      <div className="text-xs text-center text-green-800">
                                        Add an image
                                      </div>
                                    </div>
                                    <input
                                      type="file"
                                      className="opacity-0"
                                      onChange={(e) => onImageUpload(e)}
                                      name="image"
                                    />
                                  </label>
                                </div>
                              </div>
                            )}
                          </div>
                          <ErrorInputComponent error={imageError} />
                        </form>
                      </div>
                      <ButtomButton
                        name={"Create"}
                        func={handleSubmit}
                        loading={buttonLoadState}
                      />
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
}
